import { Link } from 'react-router-dom';
import '../styles/More.css';
import {
    InfoCircleFill
} from 'react-bootstrap-icons';

export default function SingleMore({moreIcon = <InfoCircleFill/>, moreTitle = 'more item', morePath = '/'}) {
    
    return (
        // TODO use Modal
        <Link to={morePath}>
        <div className='item more' title={moreTitle}>
            <div className='icon'>{moreIcon}</div>
            <p>{moreTitle}</p>
        </div>        
        </Link>
    )
}